import { render, staticRenderFns } from "./ProductListTable.vue?vue&type=template&id=33c08515&scoped=true&"
import script from "./ProductListTable.vue?vue&type=script&lang=js&"
export * from "./ProductListTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductListTable.vue?vue&type=style&index=0&id=33c08515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c08515",
  null
  
)

export default component.exports